// Add new events to this list. Newest at top.
// status: "upcoming" | "past"

export const EVENTS = [
  {
    slug: "arjuna-space-ai-india-2026",
    title: "Arjuna Space AI India",
    tagline: "Space · Intelligence · Impact",
    status: "upcoming",
    date: "2026-10-18",
    dateLabel: "Sunday, October 18th, 2026",
    time: "12:00 PM. 4:00 PM",
    workshop: "Satellite Mission Workshop · 9:30 AM. 11:30 AM (Grades 7+)",
    venue: "Intelux Electronics. Kikvi Office",
    address:
      "Intelux Electronics Pvt. Ltd. · Gat No. 1203, Kikvi, Tal. Haveli, Pune. 412 308",
    city: "Pune, Maharashtra",
    summary:
      "Explore how AI and satellite technology are solving real-world challenges on Earth and beyond. Open to all allies and future innovators.",
    registerBy: "October 4, 2026",
    registerUrl:
      "https://docs.google.com/forms/d/e/1FAIpQLSdUiv5zK8Cv4tZACrOPHaPfvS41AJ0x-jJniHBJjS_30yOAYQ/viewform",
    posterUrl:
      "https://customer-assets-agu9un31.emergentagent.net/job_ocean-farm-intel/artifacts/rofh5m0l_ChatGPT%20Image%20Sep%201%2C%202026%2C%2010_49_47%20AM.png",
    coverAccent: "#FF7A1A",
    tags: ["Community", "Workshop", "All Ages"],
    highlights: [
      "Real Satellites",
      "Live Earth Data",
      "Hands-on AI",
      "Build the Future",
    ],
    pillars: [
      { title: "Satellites", desc: "See beyond the horizon" },
      { title: "AI & Data", desc: "Turning data into decisions" },
      { title: "Earth Impact", desc: "Solving real-world challenges" },
      { title: "Future Innovators", desc: "Building together for tomorrow" },
    ],
  },
];

export const getEventBySlug = (slug) => EVENTS.find((e) => e.slug === slug);
export const getUpcomingEvents = () => EVENTS.filter((e) => e.status === "upcoming");
export const getPastEvents = () => EVENTS.filter((e) => e.status === "past");
